import SavedFeaturedProfile from './SavedFeaturedProfile';
export default SavedFeaturedProfile;